import { createAction } from 'redux-actions';
import types from '../types';

/**
 * Redux action to select a page
 * @param {string} payload.page
 */
export const selectPage = createAction(types.SELECT_PAGE);
